import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, TextField } from '@mui/material'
import React from 'react'

export default function InputSearch({value, onChange, placeholder}) {
    return (
        <Box class="col-lg-3 col-md-12">
            <Box className='backgroundField'>
                <TextField variant="standard" value={value} onChange={onChange} fullWidth placeholder={placeholder}
                    InputProps={{
                        disableUnderline: true,
                        startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                    }}
                />
            </Box>
        </Box>
    )
}
